/**
 * Pazarlama: MBD'nin kendi kampanyaları ve geri kazanım (07.10.2026).
 *
 * `metin/ortak.ts`in kuralı burada da geçerli: metin veri. Kod değerleri (`INTERNAL`,
 * `SUSPENDED`, `TOO_OLD`) çevrilmiyor, yalnız ekrana yazılırken karşılığı gösteriliyor;
 * karşılığı olmayan kodun kendisi yazılıyor, çünkü eksik görünür, uydurulmuş görünmez.
 */

export const KAMPANYA_KAYNAK: Readonly<Record<string, string>> = {
  ALL: 'Tümü',
  INFLUENCER: 'Influencer',
  INTERNAL: 'MBD iç',
};

export const KAMPANYA_DURUMU: Readonly<Record<string, string>> = {
  ACTIVE: 'Etkin',
  SUSPENDED: 'Askıda',
};

export const KOD_YAYIN_DURUMU: Readonly<Record<string, string>> = {
  PUBLISHED: 'Yayında',
  PENDING: 'Yayınlanmadı',
};

/** Sunucunun `reason` kodlarının karşılığı. Bilinmeyen kod olduğu gibi gösterilir. */
export const KAMPANYA_RET: Readonly<Record<string, string>> = {
  ALL_CATALOGUE_NOT_CONFIRMED: 'Ürün seçilmedi. Tüm katalog için geçerli olmasını istiyorsanız kutuyu işaretleyin.',
  SCOPE_CONFLICT: 'Ürün listesi ile tüm katalog birlikte seçilemez.',
  BUDGET_EXCEEDED: 'Toplam bütçe aşılıyor: kod sayısı, kod başına kullanım ve tutar çarpımı bütçeden büyük.',
  VALIDITY_WINDOW_INVALID: 'Bitiş, başlangıçtan sonra olmalı.',
  CODE_INVALID: 'Kod 3-64 karakter olmalı: A-Z, 0-9, nokta, tire ya da alt çizgi.',
  CODE_TAKEN: 'Bu kod zaten var.',
  CODE_GENERATION_EXHAUSTED: 'Bu ön ekle yeterli boş kod kalmadı. Başka bir ön ek deneyin.',
  PREFIX_REQUIRED: 'Toplu üretim için ön ek gerekli.',
  CODES_EMPTY: 'Kod için ad ya da adet girin.',
  SCOPE_UNSUPPORTED: 'Kapsam kabul edilmedi.',
  UNKNOWN_CAMPAIGN: 'Kampanya bulunamadı.',
};

export const KAMPANYA_METIN = {
  liste: {
    ustBaslik: 'Kampanyalar ve kuponlar',
    baslik: 'Kampanya listesi',
    tarif: 'Influencer kuponları ve MBD\'nin kendi kampanyaları tek listede. İç kampanyada influencer ataması ve komisyon yoktur; influencer kampanyaları burada yalnız okunur.',
    kaynak: 'Kaynak',
    yeni: 'Yeni iç kampanya',
    yenile: 'Yenile',
    sutunKampanya: 'Kampanya',
    sutunKaynak: 'Kaynak',
    sutunIndirim: 'İndirim',
    sutunGecerlilik: 'Geçerlilik',
    sutunKod: 'Kod',
    sutunKullanilan: 'Kullanılan',
    sutunKalan: 'Kalan',
    sutunDurum: 'Durum',
    sinirsiz: 'Sınırsız',
    influencerAdi: 'Influencer kampanyası',
    influencerAlt: 'Influencer',
    kampanyaAlt: 'kod',
    butce: 'bütçe',
    yayinlanmayan: 'yayınlanmamış kod',
    bos: 'Bu kaynakta kampanya yok.',
    yukleniyor: 'Yükleniyor',
    hata: 'Kampanyalar okunamadı.',
    detay: 'Kodlar',
    sayim: 'kampanya',
  },
  detay: {
    baslik: 'Kodlar',
    sutunKod: 'Kod',
    sutunDurum: 'Durum',
    sutunKullanim: 'Kullanım',
    sutunYayin: 'Yayın',
    sutunSon: 'Son tarih',
    askiyaAl: 'Kampanyayı askıya al',
    devamEt: 'Kampanyayı sürdür',
    askiOnay: 'Askıya alınan kampanyanın kodları sitede reddedilir.',
    kodEkle: 'Kod ekle',
    bos: 'Bu kampanyanın kodu yok.',
    kapat: 'Kapat',
    kapsam: 'Kapsam',
    tumKatalog: 'Tüm katalog',
    urunler: 'Ürünler',
    kalkis: 'Kalkış aralığı',
    asgari: 'Asgari sepet',
    kodBasinaSinir: 'Kod başına kullanım',
  },
  form: {
    ustBaslik: 'Yeni iç kampanya',
    baslik: 'Kampanya formu',
    tarif: 'Tek sayfa. Kodlar kampanyayla birlikte üretilir ve siteye yayımlanır.',
    ad: 'Ad',
    tutar: 'Tutar',
    paraBirimi: 'Para birimi',
    urunKapsami: 'Ürün kapsamı',
    urunAra: 'Ürün kimliği ekle',
    urunEkle: 'Ekle',
    urunKaldir: 'Kaldır',
    urunIpucu: 'v3 ürün kimliği yazılır (örnek: 2000955). Boş bırakılırsa tüm katalog için geçerli olur ve ayrıca onay istenir.',
    tumKatalog: 'Tüm katalog için geçerli olsun',
    kalkisAraligi: 'Kalkış aralığı',
    kalkisIpucu: 'Boş bırakılırsa kalkış tarihine bakılmaz.',
    asgariSepet: 'Asgari sepet',
    asgariIpucu: 'Kampanya para biriminde. Boşsa sepet tutarına bakılmaz.',
    kodBasinaSinir: 'Kod başına kullanım sınırı',
    toplamButce: 'Toplam bütçe',
    butceIpucu: 'Üretilen kod sayısı, kod başına kullanım ve tutarın çarpımı bu rakamı geçemez. Boşsa tavan yok.',
    gecerlilik: 'Geçerlilik',
    kod: 'Kod',
    kodYok: 'Şimdi kod üretme',
    kodTek: 'Tek kod',
    kodToplu: 'Toplu kod üret',
    kodAdi: 'Kod',
    onEk: 'Ön ek',
    adet: 'Adet',
    kodOrnek: 'Örnek: VIZE-7K4M. Karışan karakterler (0 O 1 I L 5 S 2 Z 8 B) kullanılmaz.',
    olustur: 'Kampanyayı oluştur ve kodları yayımla',
    olusturuluyor: 'Oluşturuluyor',
    olustu: 'Kampanya oluşturuldu.',
    yayinlanamayan: 'kod siteye yayımlanamadı; listeden yeniden denenebilir.',
    uretilen: 'kod üretildi',
    hataTutar: 'Tutar geçerli bir sayı olmalı.',
    hataAd: 'Kampanya adı gerekli.',
    hataTarih: 'Geçerlilik tarihlerini seçin.',
    hataKalkis: 'Kalkış aralığının iki ucunu da seçin ya da temizleyin.',
    hata: 'Kampanya oluşturulamadı.',
    vazgec: 'Vazgeç',
  },
} as const;

export const GERI_KAZANIM_TETIK: Readonly<Record<string, string>> = {
  VISA_CART: 'Ödenmemiş vize sepeti',
  TOUR_CART: 'Ödenmemiş tur sepeti',
  HOTEL_CART: 'Ödenmemiş otel sepeti',
};

export const GERI_KAZANIM_SONUC: Readonly<Record<string, string>> = {
  WOULD_SEND: 'Gidecekti',
  SENT: 'Gönderildi',
  FAILED: 'Hata',
  SKIPPED: 'Atlandı',
};

export const GERI_KAZANIM_ATLAMA: Readonly<Record<string, string>> = {
  TOO_OLD: 'En geç süre geçti',
  EXCLUDED_ADDRESS: 'Hariç tutulan adres',
  BOUGHT_ELSEWHERE: 'Başka sepetten satın aldı',
  FREQUENCY_LIMIT: 'Sıklık sınırı: bu adrese yakın zamanda gönderildi',
  NO_CAMPAIGN: 'Kupon kampanyası seçilmemiş',
  OUT_OF_SCOPE: 'Ürün kampanya kapsamı dışında',
  NO_ADDRESS: 'Adres yok',
  INTERNAL_ACCOUNT: 'İç ya da test hesabı (v3 işaretledi)',
  CONSENT_BLOCKED: 'Pazarlama izni yok',
};

export const GERI_KAZANIM_METIN = {
  ustBaslik: 'Geri kazanım',
  baslik: 'Geri kazanım otomasyonları',
  tarif: 'Gönderimi CRM yapar. Site yalnız sepet olaylarını ve sonradan ödeme ya da iptali bildirir. Her e-postada çalışan çıkış bağlantısı ve BAE PDPL dayanağı kendiliğinden eklenir.',
  yukleniyor: 'Yükleniyor',
  hata: 'Geri kazanım ayarları okunamadı.',
  kapali: 'Kapalı: hiçbir şey olmaz.',
  kuru: 'Kuru kip: kimseye e-posta gitmez, kupon üretilmez. "Kime gidecekti" listesi birikir.',
  canli: 'Canlı: uygun sepetlere e-posta gider ve tek kullanımlık kupon üretilir.',
  hazirDegil: 'Canlı gönderim başlayamaz',
  acik: 'Otomasyon açık',
  kuruKip: 'Kuru kip',
  bekleme: 'Bekleme (saat)',
  enGec: 'En geç (gün)',
  siklik: 'Aynı adrese sıklık (gün)',
  kuponKampanyasi: 'Kupon kampanyası',
  kampanyaSec: 'Seçilmedi',
  hariclar: 'Hariç tutulan adresler (her satıra bir adres ya da @alanadi)',
  hariclarIpucu: 'Test ve iç hesaplar buraya yazılır; bu adreslere hiçbir zaman gönderilmez.',
  sablon: 'E-posta şablonu',
  sablonIpucu: 'Kullanılabilen alanlar: {{ad}}, {{kupon}}, {{tutar}}, {{son_tarih}}, {{sepet_baglantisi}}. Çıkış bağlantısı ve dayanak cümlesi şablondan bağımsız eklenir.',
  konuTr: 'Konu (Türkçe)',
  konuEn: 'Konu (İngilizce)',
  govdeTr: 'Gövde, HTML (Türkçe)',
  govdeEn: 'Gövde, HTML (İngilizce)',
  duzTr: 'Düz metin (Türkçe)',
  duzEn: 'Düz metin (İngilizce)',
  gonderen: 'Gönderen info@mbdtravel.com, yanıt adresi info@mbdtravel.com. Adresler ortam ayarından gelir, burada değiştirilmez.',
  kaydet: 'Kaydet',
  kaydediliyor: 'Kaydediliyor',
  kaydedildi: 'Kaydedildi.',
  simdiCalistir: 'Şimdi çalıştır',
  calisiyor: 'Çalışıyor',
  calistirildi: 'Tarama tamamlandı',
  sayac: {
    gonderilen: 'Gönderilen',
    gidecekti: 'Gidecekti (kuru)',
    kuponKullanilan: 'Kupon kullanılan',
    odenen: 'Gönderimden sonra ödenen',
    atlanan: 'Atlanan',
    hatali: 'Hatalı',
  },
  gecmis: 'Gönderim ve atlanma geçmişi',
  sutunSepet: 'Sepet',
  sutunDil: 'Dil',
  sutunTutar: 'Tutar',
  sutunSonuc: 'Sonuç',
  sutunNeden: 'Neden',
  sutunKupon: 'Kupon',
  sutunKuponKullanildi: 'Kupon kullanıldı',
  sutunOdendi: 'Ödendi',
  sutunZaman: 'Zaman',
  evet: 'Evet',
  hayir: 'Hayır',
  gecmisBos: 'Henüz kayıt yok. Site sepet olaylarını bildirmeye başlayınca satırlar burada birikir.',
  tumSonuclar: 'Tüm sonuçlar',
  onceki: 'Önceki',
  sonraki: 'Sonraki',
  sayfa: 'Sayfa',
  ret: {
    CAMPAIGN_REQUIRED: 'Canlı gönderim için kupon kampanyası seçilmeli.',
    AUTOMATION_INVALID: 'Süre değerleri geçersiz: bekleme en az 1 saat, en geç süre beklemeden uzun olmalı.',
    UNKNOWN_CAMPAIGN: 'Seçilen kampanya bir MBD iç kampanyası değil.',
  } as Readonly<Record<string, string>>,
} as const;
